const $nav = {
  header: document.querySelector('.js-st-Header'),
  nav: document.querySelector('.js-st-Header__nav'),
  anchor: document.querySelectorAll('.js-st-Header__nav .js-anchor'),
  body: document.querySelector('.js-st-Header__navBody'),
  cover: document.querySelector('.js-st-Header__navCover'),
  toggle: document.querySelector('.js-st-Header__navToggle')
}

let anchorLength = $nav.anchor.length;

var scrollFunc = function(e) {
  e.preventDefault();
}

for(let i = 0; i < anchorLength; i++) {
  $nav.anchor[i].addEventListener('click', function(){
    window.removeEventListener( 'touchmove' , scrollFunc, { passive: false });
    $nav.cover.classList.remove('is-show');
    $nav.toggle.classList.remove('is-active');
    $nav.body.classList.remove('is-show');

  });
}

$nav.toggle.onclick = function() {

  if($nav.toggle.classList.contains('is-active')) {
    window.removeEventListener( 'touchmove' , scrollFunc, { passive: false });
    $nav.cover.classList.remove('is-show');
    $nav.toggle.classList.remove('is-active');
    $nav.body.classList.remove('is-show');


  } else {
    window.addEventListener( 'touchmove' , scrollFunc, { passive: false });
    $nav.body.classList.add('is-show');
    $nav.toggle.classList.add('is-active');
    setTimeout(function(){
      $nav.cover.classList.add('is-show');
    }, 300);
  }
}
